var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MenuMui from '@mui/material/Menu';
import React from 'react';
import { css } from '@corti/style';
import { useTheme } from '@corti/theme';
/**
 * A Menu displays a list of choices on a temporary surface. It appears when the user interacts with a button, or other control.
 */
const Menu = (props) => {
    const rest = __rest(props, []);
    const theme = useTheme();
    return (React.createElement(MenuMui, Object.assign({ transitionDuration: 0, MenuListProps: {
            classes: {
                root: css({
                    backgroundColor: theme.palette.background.card,
                }),
            },
        } }, rest)));
};
export { Menu };
